import { render, staticRenderFns } from "./RegulationModal.vue?vue&type=template&id=a20540e0&scoped=true"
import script from "./RegulationModal.vue?vue&type=script&lang=js"
export * from "./RegulationModal.vue?vue&type=script&lang=js"
import style0 from "./RegulationModal.vue?vue&type=style&index=0&id=a20540e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20540e0",
  null
  
)

export default component.exports